export const LOCAL_STORAGE = {
  STORE: 'application.store',
}

export const WEB_URL = 'https://startupcraft.io'

export const APP_ENV = {
  LOCALHOST: 'localhost',
  STAGING: 'staging',
  PRODUCTION: 'production',
}

export const WORKLAIR_SUPPORT_WIDGET = {
  STAGING: {
    SRC: 'https://files.staging.worklair.io/support-widget/index.js',
    ID: '3dfff5ed-52f4-487e-a303-778b76950ca0',
  },
  PRODUCTION: {
    SRC: 'https://files.worklair.io/support-widget/index.js',
    ID: 'ad52f1c0-f2dc-4365-827f-8d4e2f316163',
  },
}
